<template>
<div>
  <div
    id="table-container"
    :class="[{'stripe': stripe, 'hoverFlat': hoverFlat}, `vs-table-${color}`]"
    class="vs-component vs-con-table vs-con-loading__container">

    <header class="header-table vs-table--header" v-if="resource">
      <slot name="header"></slot>

      <div class="con-input-pagesize vs-table--pagesize">
        <vs-select :value="resource.page.size"
                   @input="onPageSize"
                   class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                   label="Page size">
          <vs-select-item :value="5" :text="'5'"/>
          <vs-select-item :value="10" :text="'10'"/>
          <vs-select-item :value="25" :text="'25'"/>
          <vs-select-item :value="50" :text="'50'"/>
          <vs-select-item :value="100" :text="'100'"/>
        </vs-select>
      </div>

      <div class="text-center pt-6">
        <span><vs-chip>{{ resource.page.totalElements }} results</vs-chip></span>
      </div>

      <div class="con-input-search vs-table--search w-full">
        <vs-input v-if="search"
                  class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  ref="search"
                  :value="params.q"
                  label="Search..."
                  @change="updateQuery">
        </vs-input>
      </div>

      <div v-if="actionsMenuVisible">
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-4">
          <vs-button icon="icon-menu" icon-pack="feather" type="border" class="mt-6"/>
          <vs-dropdown-menu class="w-48">
            <slot name="actions">
              <template v-if="actions">
                    <vs-dropdown-item v-for="(action, index) in actions" :key="index">
                    <span class="flex items-center" @click="handleAction(action)">
                      <feather-icon :icon="action.icon" svgClasses="h-4 w-4" class="mr-2"/>
                      <span>{{ action.title }}</span>
                    </span>
                </vs-dropdown-item>
              </template>
            </slot>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </header>

    <div v-if="resource" class="con-tablex vs-table--content">
      <div :style="styleConTbody" class="vs-con-tbody vs-table--tbody ">
        <table
          class="vs-table vs-table--tbody-table"
          ref="table">
          <thead
            class="vs-table--thead"
            ref="thead">
          <tr>
            <slot name="thead"></slot>
          </tr>
          </thead>
          <slot :data="data"></slot>
        </table>
      </div>

      <div v-if="isNoData" class="not-data-table vs-table--not-data">
        No data available
      </div>

      <div v-if="pagination && resource" class="con-pagination-table vs-table--pagination">
        <sm-pagination
          :paged-resources="resource"
          @change="onPageNumber"></sm-pagination>
      </div>
    </div>
  </div>
  <vs-prompt
    @cancel="cancelFilePassword"
    @accept="acceptFilePassword"
    @close="cancelFilePassword"
    :active.sync="filePasswordActive"
    :title="$t('common.download.prompt.title')"
    :is-valid="validFilePassword">
    <div class="con-exemple-prompt">
      <p v-html="$t('common.download.prompt.content')"></p>
      <vs-input class="w-full my-10" :placeholder="$t('common.download.prompt.placeholder')" v-model="filePassword"
                :danger="!validFilePassword"
                :danger-text="$t('common.download.prompt.error')"/>
    </div>
  </vs-prompt>
</div>
</template>

<script>
import { saveAs } from 'file-saver';
import { ResourceImpl } from 'hal-client';
import { downloadableDocumentsBus } from '../../../layouts/components/navbar/components/DownloadableDocumentDropDown';
import SmPagination from '../sm-pagination/sm-pagination';

export default {
  name: 'sm-hateoas-table',
  components: {SmPagination},
  props: {
    pagedResources: {
      type: ResourceImpl,
      required: true
    },
    relation: {
      type: String,
      required: true
    },
    color: {
      default: 'primary',
      type: String
    },
    stripe: {
      default: false,
      type: Boolean
    },
    hoverFlat: {
      default: false,
      type: Boolean
    },
    maxHeight: {
      default: 'auto',
      type: String
    },
    multiple: {
      default: false,
      type: Boolean
    },
    notSpacer: {
      default: false,
      type: Boolean
    },
    search: {
      default: false,
      type: Boolean
    },
    sorts: {
      default () {
        return [];
      },
      type: Array
    },
    pagination: {
      default: false,
      type: Boolean
    },
    currentPage: {
      default: 1,
      type: Number | String
    },
    sst: {
      default: false,
      type: Boolean
    },
    onlyClickCheckbox: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: null
    },
    actionsMenu: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      resource: undefined,
      params: {
        q: null,
        page: this.pagedResources.page.number,
        size: this.pagedResources.page.size,
        sort: ''
      },
      currentSortKey: null,
      currentSortType: null,
      acceptedActions: [
        {
          name: 'download-xlsx',
          title: 'Download Excel File',
          icon: 'DownloadIcon'
        }
      ],
      filePassword: null,
      filePasswordActive: false,
      action: null
    };
  },
  computed: {
    data () {
      const data = this.resource && this.resource.$hasEmbedded(this.relation) ? this.resource.$getEmbedded(this.relation) : [];
      return data;
    },
    isNoData () {
      return !this.resource || this.resource.page.totalElements === 0;
    },
    styleConTbody () {
      return {
        maxHeight: this.maxHeight,
        overflow: this.maxHeight !== 'auto' ? 'auto' : null
      };
    },
    actionsMenuVisible () {
      return this.actionsMenu || this.actions || this.multiple;
    },
    actions () {
      const actions = this.acceptedActions.filter(action => this.resource.$hasLink(`actions-${action.name}`));
      return actions && actions.length ? actions : null;
    },
    validFilePassword () {
      return this.filePassword && this.filePassword.length > 4;
    }
  },
  watch: {
    params: {
      deep: true,
      handler (value) {
        if (!this.resource) return;
        this.$vs.loading({
          container: '#table-container',
          scale: 0.6
        });
        this.resource.$request()
          .$get('search', Object.assign({}, this.filters, value))
          .then((res) => {
            this.resource = res;
            this.$emit('updateMembersData', res.page.size, res.$getEmbedded('member-reports'), false);
            this.$vs.loading.close('#table-container > .con-vs-loading');
          });
      }
    },
    pagedResources: {
      handler (value) {
        value.$request().$get('search').then(res => {
          this.resource = res;
        });
      }
    },
    filters: {
      deep: true,
      handler (value) {
        if (!this.resource) return;
        this.$vs.loading({
          container: '#table-container',
          scale: 0.6
        });
        this.params.page = 0;
        this.resource.$request()
          .$get('search', Object.assign({}, this.params, value))
          .then((res) => {
            this.resource = res;
            this.$emit('updateMembersData', res.page.size, res.$getEmbedded('member-reports'), true);
            this.$vs.loading.close('#table-container > .con-vs-loading');
          });
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.listenerChangeWidth);
    this.pagedResources.$request().$get('search').then(res => {
      this.resource = res;
    });
  },
  destroyed () {
    window.removeEventListener('resize', this.listenerChangeWidth);
  },
  methods: {
    clicktr (tr, isTr) {
      if (this.multiple && isTr && !this.onlyClickCheckbox) {
        const val = this.value.slice(0);
        if (val.includes(tr)) {
          val.splice(val.indexOf(tr), 1);
        } else {
          val.push(tr);
        }

        this.$emit('input', val);
        this.$emit('selected', tr);
      } else if (isTr && !this.onlyClickCheckbox) {
        this.$emit('input', tr);
        this.$emit('selected', tr);
      }
    },
    refresh () {
      if (!this.resource) return;
      this.$vs.loading({
        container: '#table-container',
        scale: 0.6
      });
      this.resource.$request()
        .$getSelf('search', Object.assign({}, this.params, this.filters))
        .then((res) => {
          this.resource = res;
          this.$vs.loading.close('#table-container > .con-vs-loading');
        });
    },
    dblclicktr () {
    },
    onPageNumber (page) {
      this.$emit('updatePageIndex', page);
      this.params.page = page;
    },
    onPageSize (pageSize) {
      this.$emit('updatePageSize', pageSize);
      this.params = {
        ...this.params,
        size: pageSize,
        page: 0
      };
    },
    sort (key, sortType) {
      if (key) {
        this.currentSortKey = key;
        this.currentSortType = sortType;
        this.$log.debug(key, sortType);
        if (!key || !sortType) {
          this.params = {
            ...this.params,
            sort: null,
            page: 0
          };
          return;
        }
        this.params = {
          ...this.params,
          sort: `${key},${sortType}`,
          page: 0
        };
      }
    },
    updateQuery (evt) {
      this.$log.debug('Updated query', evt.target.value);
      this.params = {
        ...this.params,
        q: evt.target.value,
        page: 0
      };
    },
    handleAction (action) {
      if (action.name === 'download-xlsx') {
        this.action = action;
        this.filePasswordActive = true;
      }
    },
    cancelFilePassword () {
      this.action = null;
      this.filePassword = null;
      this.filePasswordActive = false;
    },
    acceptFilePassword () {
      this.$vs.notify({
        title: 'Download in progress',
        text: 'The Excel file is being processed — your download will begin shortly.',
        iconPack: 'feather',
        icon: 'icon-loader',
        color: 'primary'
      });

      this.$http.get(this.resource.$href(`actions-${this.action.name}`, Object.assign({}, this.filters, this.params)), {
        headers: {
          'X-SM-CHOSEN_PASSWORD': this.filePassword,
          'Accept': 'application/vnd.starling.excel'
        },
        responseType: 'blob'
      }).then(res => {
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition) {
          const filename = contentDisposition && contentDisposition.indexOf('filename') ? contentDisposition.split('filename="')[1].split('"')[0] : 'file-download.xlsx';
          saveAs(res.data, filename);

          this.$vs.notify({
            title: 'Excel Export Downloaded!',
            text: 'The Excel export has been generated and downloaded successfully.',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          this.$vs.notify({
            title: 'Excel Export is started!',
            text: 'The Excel export is currently being generated. You\'ll be able to download it soon..',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
          downloadableDocumentsBus.$emit('refresh');
        }
      }, () => {
        this.$vs.notify({
          title: 'Excel Export Error',
          text: 'The Excel export could not be generated.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }).finally(() => {
        this.action = null;
        this.filePassword = null;
      });
    }
  }
};
</script>
